import styled from 'styled-components';

import DischargeCalendarIcon from 'svg/DischargeCalendarIcon';
import ListIcon from 'svg/ListIcon';

interface ViewModeToggleProps {
  isListView: boolean;
  onToggle: (isListView: boolean) => void;
}

export default function ViewModeToggle({ isListView, onToggle }: ViewModeToggleProps) {
  return (
    <Container>
      <ToggleButton $active={!isListView} onClick={() => onToggle(false)} aria-label='Calendar view' type='button'>
        <DischargeCalendarIcon />
      </ToggleButton>
      <ToggleButton $active={isListView} onClick={() => onToggle(true)} aria-label='List view' type='button'>
        <ListIcon />
      </ToggleButton>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.black25};
  border-radius: 4px;
  overflow: hidden;
  height: 38px;
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  padding: 8px 12px;
  border: none;
  background-color: ${({ $active, theme }) => ($active ? theme.colors.blue100 : 'transparent')};
  color: ${({ $active, theme }) => ($active ? theme.colors.white : theme.colors.black100)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black25};
  }
`;
